// extracted by mini-css-extract-plugin
export default {"WarningIconEmailVerified":"withUserInfo_WarningIconEmailVerified__Yh0I5"};